import React, { useState, useEffect } from "react";
import firebase from "firebase/compat/app";
import { auth } from "../firebase";

import {
  Table,
  Button,
  Space,
  Input,
  Select,
  Tooltip,
  Typography,
  Empty,
} from "antd";
import { Switch } from "antd";
import { DeleteTwoTone, LockTwoTone } from "@ant-design/icons";
import CS_AND_ALLIED_BRANCHES from "../cs_and_allied_branches";

const { Column } = Table;
const { Search } = Input;
const { Option } = Select;

const TableComponent = () => {
  const [loading, setLoading] = useState(false);

  const tableRef = React.useRef(null);
  const [filteredInfo, setFilteredInfo] = useState({});
  const [highlightTable, setHighlightTable] = useState(false);
  const [selectedCategory, setSelectedCategory] = useState("GM");
  const [selectedColleges, setSelectedColleges] = useState([]);
  const [selectedBranches, setSelectedBranches] = useState([]);
  const [selectedPlaces, setSelectedPlaces] = useState(["Bengaluru"]);
  const [placeOpen, setPlaceOpen] = useState(false);
  const [collegeOpen, setCollegeOpen] = useState(false);
  const [branchOpen, setBranchOpen] = useState(false);

  const [data, setData] = useState([]);
  const [uniqueBranchNames, setUniqueBranchNames] = useState([]);
  const [onlyCSAndAlliedBranches, setOnlyCSAndAlliedBranches] = useState(false);

  const [displayShortName, setDisplayShortName] = useState(true);
  const [showNulls, setShowNulls] = useState(false);
  const [showCodeColumn, setShowCodeColumn] = useState(false);
  const [showPlaceColumn, setShowPlaceColumn] = useState(false);
  const [userRank, setUserRank] = useState(0);

  const [user, setUser] = useState(null);

  // fetch
  useEffect(() => {
    fetch("/GR_3R_2025.json")
      .then((res) => res.json())
      .then((data) => {
        setData(data);

        setUniqueBranchNames([...new Set(data.map((i) => i.branch_name))]);
        // console.log("branches", [...new Set(data.map((i) => i.branch_name))]);
      });
  }, []);

  // loader
  useEffect(() => {
    setLoading(true);
    const t = setTimeout(() => setLoading(false), 500);
    return () => clearTimeout(t);
  }, [
    selectedColleges,
    selectedBranches,
    selectedPlaces,
    selectedCategory,
    userRank,
    showNulls,
  ]);

  useEffect(() => {
    if (!loading) {
      setHighlightTable(true);

      const t = setTimeout(() => {
        setHighlightTable(false);
      }, 2000);

      return () => clearTimeout(t);
    }
  }, [loading]);

  // auth
  useEffect(() => {
    const unsub = firebase.auth().onAuthStateChanged((u) => setUser(u));
    return () => unsub();
  }, []);

  const uniquePlaces = [...new Set(data.map((i) => i.place))];
  const uniqueCollegeNames = [...new Set(data.map((i) => i.college_full_name))];

  const collegeNameType = displayShortName
    ? "college_short_name"
    : "college_full_name";
  const branchNameType = displayShortName ? "branch_code" : "branch_name";

  // filtering
  const filteredData = data.filter((item) => {
    if (
      selectedColleges.length &&
      !selectedColleges.includes(item.college_full_name)
    )
      return false;
    if (
      selectedBranches.length &&
      !selectedBranches.some((b) =>
        item.branch_name.toLowerCase().includes(b.toLowerCase()),
      )
    )
      return false;
    if (selectedPlaces.length && !selectedPlaces.includes(item.place))
      return false;
    if (item[`cutoff_rank_${selectedCategory}`] < userRank) return false;
    return true;
  });

  const filteredDataWithNulls = showNulls
    ? filteredData
    : filteredData.filter(
        (item) => item[`cutoff_rank_${selectedCategory}`] != null,
      );

  const branchMap = {};
  data.forEach((i) => {
    branchMap[i.branch_name] = i.branch_code;
  });

  const clearFilters = () => {
    setSelectedColleges([]);
    setSelectedBranches([]);
    setSelectedPlaces([]);
    setFilteredInfo({});
  };

  const tooltipText = (
    <span>
      <a
        onClick={() =>
          auth.signInWithPopup(new firebase.auth.GoogleAuthProvider())
        }>
        Sign in to unlock reservation category filter!
      </a>
    </span>
  );

  return (
    <div>
      <div style={{ display: "flex", justifyContent: "center" }}>
        <div style={{ width: "100%", maxWidth: "600px" }}>
          {/* ✅ Rank Section */}
          <div
            style={{
              padding: "12px",
              border: "1px solid #eee",
              borderRadius: "8px",
              marginBottom: "16px",
              textAlign: "center",
            }}>
            <Typography.Title level={5}>🎯 Enter Your Rank</Typography.Title>

            <Search
              placeholder="Enter your rank"
              enterButton="Search"
              type="number"
              allowClear
              onSearch={(v) => {
                setUserRank(parseInt(v));
                tableRef.current?.scrollIntoView({ behavior: "smooth" });
              }}
              style={{ width: "100%" }}
            />

            <p style={{ color: "gray", marginTop: "6px" }}>
              OR use filters below
            </p>
          </div>

          {/* ✅ Filters */}
          <div
            style={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              gap: "10px",
            }}>
            <Button onClick={clearFilters} style={{ width: "100%" }}>
              <DeleteTwoTone /> Clear Filters
            </Button>

            <Space wrap style={{ justifyContent: "center" }}>
              <Switch
                checkedChildren="Short"
                unCheckedChildren="Short"
                defaultChecked
                onChange={setDisplayShortName}
              />
              <Switch
                checkedChildren="Nulls"
                unCheckedChildren="Nulls"
                onChange={setShowNulls}
              />
              <Switch
                checkedChildren="Place"
                unCheckedChildren="Place"
                onChange={setShowPlaceColumn}
              />
              <Switch
                checkedChildren="CET Codes"
                unCheckedChildren="CET Codes"
                onChange={setShowCodeColumn}
              />
            </Space>

            <div style={{ marginBottom: "6px" }}>
              {" "}
              <Space>
                {" "}
                <Switch
                  checkedChildren="CS & allied only"
                  unCheckedChildren="CS & allied only"
                  checked={onlyCSAndAlliedBranches}
                  onChange={(checked) => {
                    if (checked) {
                      setSelectedBranches(CS_AND_ALLIED_BRANCHES);
                    } else {
                      setSelectedBranches([]);
                    }
                    setOnlyCSAndAlliedBranches(checked);
                  }}
                />{" "}
              </Space>{" "}
            </div>

            <Tooltip title={!user ? tooltipText : null}>
              <Select
                placeholder="Category"
                value={selectedCategory}
                onChange={setSelectedCategory}
                disabled={!user}
                style={{ width: "100%" }}>
                <Option value="GM">
                  {!user ? (
                    <span>
                      <LockTwoTone /> GM
                    </span>
                  ) : (
                    "GM"
                  )}
                </Option>
                <Option value="GMK">GMK</Option>
                <Option value="GMR">GMR</Option>
                <Option value="1G">1G</Option>
                <Option value="1K">1K</Option>
                <Option value="1R">1R</Option>
                <Option value="2AG">2AG</Option>
                <Option value="2AK">2AK</Option>
                <Option value="2AR">2AR</Option>
                <Option value="2BG">2BG</Option>
                <Option value="2BK">2BK</Option>
                <Option value="2BR">2BR</Option>
                <Option value="3AG">3AG</Option>
                <Option value="3AK">3AK</Option>
                <Option value="3AR">3AR</Option>
                <Option value="3BG">3BG</Option>
                <Option value="3BK">3BK</Option>
                <Option value="3BR">3BR</Option>

                <Option value="SCG">SCG</Option>
                <Option value="SCK">SCK</Option>
                <Option value="SCR">SCR</Option>
                <Option value="STG">STG</Option>
                <Option value="STK">STK</Option>
                <Option value="STR">STR</Option>
              </Select>
            </Tooltip>

            <Select
              mode="multiple"
              placeholder="Place"
              value={selectedPlaces}
              open={placeOpen}
              onDropdownVisibleChange={(val) => setPlaceOpen(val)}
              onChange={(value) => {
                setSelectedPlaces(value);
                setPlaceOpen(false); // close after select
              }}
              style={{ width: "100%" }}>
              {uniquePlaces.sort().map((p) => (
                <Option key={p}>{p}</Option>
              ))}
            </Select>

            <Select
              mode="multiple"
              placeholder="College"
              allowClear
              value={selectedColleges}
              open={collegeOpen}
              onDropdownVisibleChange={(val) => setCollegeOpen(val)}
              onChange={(value) => {
                setSelectedColleges(value);
                setCollegeOpen(false); // close after select
              }}
              style={{ width: "100%" }}>
              {uniqueCollegeNames.sort().map((c) => (
                <Option key={c}>{c}</Option>
              ))}
            </Select>

            {/* <Select
              mode="multiple"
              placeholder="Branch"
              value={selectedBranches}
              onChange={setSelectedBranches}
              style={{ width: "100%" }}
              maxTagCount={50}
              tagRender={(props) => {
                const { value } = props;
                return (
                  <span style={{ marginRight: 4 }}>
                    {branchMap[value] || value}
                  </span>
                );
              }}>
              {uniqueBranchNames.map((b) => (
                <Option key={b}>{b}</Option>
              ))}
            </Select> */}

            {/* <Select
              mode="multiple"
              placeholder="Branch"
              value={selectedBranches}
              onChange={setSelectedBranches}
              style={{ width: "100%" }}
              maxTagCount={onlyCSAndAlliedBranches ? 5 : "responsive"}
              tagRender={(props) => {
                const { value, closable, onClose } = props;

                const code =
                  data.find((i) => i.branch_name === value)?.branch_code ||
                  value;

                // 👉 if CS toggle ON → custom chip
                if (onlyCSAndAlliedBranches) {
                  return (
                    <span
                      onClick={(e) => e.stopPropagation()}
                      style={{
                        background: "#e6f4ff",
                        padding: "2px 8px",
                        borderRadius: "12px",
                        marginRight: 4,
                        fontSize: "12px",
                      }}>
                      {code}
                      {closable && (
                        <span onClick={onClose} style={{ marginLeft: 4 }}>
                          ❌
                        </span>
                      )}
                    </span>
                  );
                }

                // 👉 if toggle OFF → normal but still show code
                return <span onClick={(e) => e.stopPropagation()}>{code}</span>;
              }}>
              {uniqueBranchNames.map((b) => {
                const code =
                  data.find((i) => i.branch_name === b)?.branch_code || b;

                return (
                  <Option key={b} value={b}>
                    {onlyCSAndAlliedBranches ? `${code} - ${b}` : code}
                  </Option>
                );
              })}
            </Select>
             */}

            <Select
              mode="multiple"
              placeholder="Branch"
              value={selectedBranches}
              allowClear
              open={branchOpen}
              onDropdownVisibleChange={(val) => setBranchOpen(val)}
              onChange={(value) => {
                setSelectedBranches(value);
                setBranchOpen(false); // close after select
              }}
              style={{ width: "100%" }}
              maxTagCount={5}
              tagRender={(props) => {
                const { value, closable, onClose } = props;

                const code =
                  data.find((i) => i.branch_name === value)?.branch_code ||
                  value;

                return (
                  <span
                    onClick={(e) => e.stopPropagation()}
                    style={{
                      background: "#e6f4ff",
                      padding: "2px 8px",
                      borderRadius: "12px",
                      marginRight: 4,
                      fontSize: "12px",
                    }}>
                    {code}
                    {closable && (
                      <span onClick={onClose} style={{ marginLeft: 4 }}>
                        ❌
                      </span>
                    )}
                  </span>
                );
              }}>
              {uniqueBranchNames.sort().map((b) => {
                const code =
                  data.find((i) => i.branch_name === b)?.branch_code || b;

                return (
                  <Option key={b} value={b}>
                    {code} - {b}
                  </Option>
                );
              })}
            </Select>
          </div>
        </div>
      </div>

      {userRank > 0 && (
        <Typography.Text style={{ marginLeft: "10px" }}>
          Showing results for rank: {userRank}
        </Typography.Text>
      )}
      {/* ✅ Table FULL WIDTH */}
      <div
        ref={tableRef}
        style={{
          width: "100%",
          maxWidth: "100%",
          marginTop: "16px",
          border: highlightTable ? "2px solid #1890ff" : "none",
          transition: "border 0.3s ease",
        }}>
        <Table
          loading={loading}
          rowKey={(r) => r.college_code + r.branch_code}
          dataSource={filteredDataWithNulls}
          locale={{
            emptyText: <Empty description="No data for selected filters 😞" />,
          }}
          scroll={{ x: "max-content" }}>
          {showCodeColumn && (
            <Column title="CET code" dataIndex="college_code" />
          )}
          <Column title="College" dataIndex={collegeNameType} />
          <Column title="Branch" dataIndex={branchNameType} />
          {showPlaceColumn && <Column title="Place" dataIndex="place" />}
          <Column
            title="Cutoff rank"
            dataIndex={`cutoff_rank_${selectedCategory}`}
            sorter={(a, b) => {
              const key = `cutoff_rank_${selectedCategory}`;
              const valA = a[key] ?? Infinity;
              const valB = b[key] ?? Infinity;
              return valA - valB;
            }}
            defaultSortOrder="ascend"
          />
        </Table>
      </div>
    </div>
  );
};

export default TableComponent;
